import SalesAuditPage from "../../pages/sales/audit/SalesAuditPage";

const route = {
  key: "salesAudit",
  path: "/sales/audit",
  component: SalesAuditPage,
  permission: "sales.audit.read",
  private: true,
  layout: "main",
  icon: "faHistory",
  group: "sales",
  order: 23
};

export default route;
